import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiTableCell']
>['styleOverrides'] = {
  root: ({ theme }) => ({
    borderColor: theme.vars.palette.grey[200],

    '& > .MuiChip-root > .MuiChip-label': {
      overflow: 'auto',
      textOverflow: 'unset',
    },
  }),
};

const MuiTableCell: Components<CssVarsTheme>['MuiTableCell'] = {
  styleOverrides,
};

export default MuiTableCell;
